<template>
  <Datatable
    id="transactions"
    entity="loyalty_transaction"
    :parameters="{branch: $route.query.branch}"
    :onRowClick="show"
    :rowActions="[{text: 'loyalty_transactions.show', method: show}]">
  </Datatable>
</template>

<script>
  import Datatable from "@/components/Datatable.vue";

  export default {
    name: "Transactions",

    components: { Datatable },

    mounted() {
      this.$store.state.pageTitleTranslationKey = "loyalty_transactions.list";
      this.$store.state.pageIcon = "/icon/loyalty.svg";
    },

    methods: {
      show(row) {
        this.$router.push(this.$router.buildContext("/loyalty-transaction", {id: row.id}));
      }
    }
  }
</script>


<style lang="scss" scoped>

</style>